import qs from 'qs';

export const buildUrl = <U extends string, P extends object>(url: U, params?: P) => {
  const query = qs.stringify(params, { encode: false, skipNulls: true, addQueryPrefix: true });
  return `${url}${query}` as const;
};
